import * as React from "react";
import Router from "next/router";
import PropTypes from "prop-types";
import BraQuizResults from "@lululemon/ecom-common/src/components/bra-quiz-results/bra-quiz-results";
import BraQuizDataContext from "@lululemon/ecom-story/src/components/quiz/utils/quizDataContext";
import QuizResultsLoadingIndicator from "./quiz-results-loading-indicator/quiz-results-loading-indicator";
import QuizUnsupportedResult from "./quiz-unsupported-size/quiz-unsupported-size";

const QuizResults = ({
  isLoading,
  quizResultsRes,
  onResetQuiz,
  isEmbedded,
  onCompleteQuiz: handleCompleteQuiz,
}) => {
  const { embeddedCopies } = React.useContext(BraQuizDataContext);

  const hasSupportedSizes =
    quizResultsRes?.sizeSupported && quizResultsRes?.cdpURL;
  const shouldRedirect = !isEmbedded;

  if (isLoading) return <QuizResultsLoadingIndicator />;

  if (!hasSupportedSizes)
    return (
      <QuizUnsupportedResult
        onResetQuiz={onResetQuiz}
        isEmbedded={isEmbedded}
      />
    );

  if (shouldRedirect) {
    const { pathname = "/" } = new URL(quizResultsRes.cdpURL);
    Router.push(pathname);

    return <QuizResultsLoadingIndicator />;
  }

  if (isEmbedded && quizResultsRes?.cdpURL) {
    const { pathname = "/" } = new URL(quizResultsRes.cdpURL);

    return (
      <BraQuizResults
        braQuizResultsData={{
          ...quizResultsRes?.sizes,
          cdpURL: pathname,
        }}
        contentfulData={embeddedCopies}
        isEmbedded
        onCompleteQuiz={handleCompleteQuiz}
      />
    );
  }

  return null;
};

QuizResults.defaultProps = {
  quizResultsRes: null,
  onCompleteQuiz: null,
  isEmbedded: false,
};

QuizResults.propTypes = {
  onCompleteQuiz: PropTypes.oneOf([null, PropTypes.func]),
  isLoading: PropTypes.bool.isRequired,
  isEmbedded: PropTypes.bool,
  quizResultsRes: PropTypes.shape({
    cdpURL: PropTypes.string,
    sizeSupported: PropTypes.bool,
    sizes: PropTypes.shape({
      americanSize: PropTypes.string,
      bandSize: PropTypes.string,
      coverages: PropTypes.arrayOf(PropTypes.string),
      letterSizeLabel: PropTypes.string,
      letteredSize: PropTypes.string,
      numberedSize: PropTypes.string,
      numberedSizeLabel: PropTypes.string,
    }),
    error: PropTypes.object,
  }),
  onResetQuiz: PropTypes.func.isRequired,
};

export default QuizResults;
